<template>
  <validated-input
    :id="'user-name-' + _uid"
    idGtm="usuario"
    :value="value"
    :validations="validations"
    :label="label"
    @input="onInput"
    :quantumObfuscate="quantumObfuscate"
  />
</template>

<script>
import ValidatedInput from "./ValidatedInput.vue";
export default {
  name: "UserNameInput",
  components: {
    ValidatedInput
  },
  props: {
    value: String,
    required: {
      type: Boolean,
      default: false
    },
    label: String,
    analyticsTypology: String,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validations: {
        maxMinLength: {
          message: "Debe tener entre 6 y 20 letras.",
          validate: value => value.length >= 6 && value.length <= 20
        },
        noSpecialChars: {
          message: "No utilizar ni números ni caracteres especiales.",
          validate: value => /^[a-zA-Z]*$/.test(value)
        }
      }
    };
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.subscribe(this);
  }
};
</script>
